import React, { FC } from 'react'
import { FlexRow } from 'components/Flex'
import { CheckLabel } from 'components/Label'
import { Spacer } from 'components/Utility'

type Props = {
  selectStatus: (value: string) => void
  status: string
  statuses: string[]
}

const OrderStatusLabels: FC<Props> = React.memo((props) => {
  const { selectStatus, status, statuses } = props
  return (
    <FlexRow justifyContent={'start'}>
      {statuses.map((_status, index) => (
        <>
          <CheckLabel isChecked={_status === status} onClick={selectStatus} value={_status} />
          <Spacer size={8} axis={'horizontal'} />
        </>
      ))}
    </FlexRow>
  )
})

export default OrderStatusLabels
